
export enum NotificationType {
  DESTINATION_ARRIVAL = 'DESTINATION_ARRIVAL',
  INTERNET_LOST = 'INTERNET_LOST',
  INTERNET_RESTORED = 'INTERNET_RESTORED',
  GPS_LOST = 'GPS_LOST',
  GPS_RESTORED = 'GPS_RESTORED',
  UPDATE_SOFTWARE_COMPLETED = 'UPDATE_SOFTWARE_COMPLETED',
  UPDATE_SOFTWARE_FAILED = 'UPDATE_SOFTWARE_FAILED',
}

export const NOTIFICATION_TYPE_DEFAULTS: Record<NotificationType, boolean> = {
  [NotificationType.DESTINATION_ARRIVAL]: true,
  [NotificationType.INTERNET_LOST]: true,
  [NotificationType.INTERNET_RESTORED]: false,
  [NotificationType.GPS_LOST]: true,
  [NotificationType.GPS_RESTORED]: false,
  [NotificationType.UPDATE_SOFTWARE_COMPLETED]: true,
  [NotificationType.UPDATE_SOFTWARE_FAILED]: true,
};

export const NOTIFICATION_TYPE_ORDER: NotificationType[] = [
  NotificationType.DESTINATION_ARRIVAL,
  NotificationType.INTERNET_LOST,
  NotificationType.INTERNET_RESTORED,
  NotificationType.GPS_LOST,
  NotificationType.GPS_RESTORED,
  NotificationType.UPDATE_SOFTWARE_COMPLETED,
  NotificationType.UPDATE_SOFTWARE_FAILED,
];

export const NOTIFICATION_MISSION_TYPES: NotificationType[] = [
  NotificationType.DESTINATION_ARRIVAL,
];

export const NOTIFICATION_CONNECTIVITY_TYPES: NotificationType[] = [
  NotificationType.INTERNET_LOST,
  NotificationType.INTERNET_RESTORED,
  NotificationType.GPS_LOST,
  NotificationType.GPS_RESTORED,
];

export const NOTIFICATION_FIRMWARE_TYPES: NotificationType[] = [
  NotificationType.UPDATE_SOFTWARE_COMPLETED,
  NotificationType.UPDATE_SOFTWARE_FAILED,
];

export const NOTIFICATION_SETTINGS_SECTIONS = [
  { titleKey: 'notifications.settingsPage.mission', types: NOTIFICATION_MISSION_TYPES },
  { titleKey: 'notifications.settingsPage.connectivity', types: NOTIFICATION_CONNECTIVITY_TYPES },
  { titleKey: 'notifications.settingsPage.firmware', types: NOTIFICATION_FIRMWARE_TYPES },
] as const;
